/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BulkUploadDocument } from './BulkUploadDocument';
import {
    BulkUploadDocumentFromJSON,
    BulkUploadDocumentFromJSONTyped,
    BulkUploadDocumentToJSON,
    BulkUploadDocumentToJSONTyped,
} from './BulkUploadDocument';

/**
 * 
 * @export
 * @interface ExecuteBulkUploadDocumentsRequest
 */
export interface ExecuteBulkUploadDocumentsRequest {
    /**
     * 
     */
    lead_ids: Array<string>;
    /**
     * 
     */
    documents: Array<BulkUploadDocument>;
    /**
     * 
     */
    include_in_ai_analysis: boolean;
}

/**
 * Check if a given object implements the ExecuteBulkUploadDocumentsRequest interface.
 */
export function instanceOfExecuteBulkUploadDocumentsRequest(value: object): value is ExecuteBulkUploadDocumentsRequest {
    if (!('lead_ids' in value) || value['lead_ids'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    if (!('include_in_ai_analysis' in value) || value['include_in_ai_analysis'] === undefined) return false;
    return true;
}

export function ExecuteBulkUploadDocumentsRequestFromJSON(json: any): ExecuteBulkUploadDocumentsRequest {
    return ExecuteBulkUploadDocumentsRequestFromJSONTyped(json, false);
}

export function ExecuteBulkUploadDocumentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExecuteBulkUploadDocumentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_ids': json['lead_ids'],
        'documents': ((json['documents'] as Array<any>).map(BulkUploadDocumentFromJSON)),
        'include_in_ai_analysis': json['include_in_ai_analysis'],
    };
}

export function ExecuteBulkUploadDocumentsRequestToJSON(json: any): ExecuteBulkUploadDocumentsRequest {
    return ExecuteBulkUploadDocumentsRequestToJSONTyped(json, false);
}

export function ExecuteBulkUploadDocumentsRequestToJSONTyped(value?: ExecuteBulkUploadDocumentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_ids': value['lead_ids'],
        'documents': ((value['documents'] as Array<any>).map(BulkUploadDocumentToJSON)),
        'include_in_ai_analysis': value['include_in_ai_analysis'],
    };
}

